import { render, staticRenderFns } from "./LoaderUpdated.vue?vue&type=template&id=a54f86be"
import script from "./LoaderUpdated.vue?vue&type=script&lang=js"
export * from "./LoaderUpdated.vue?vue&type=script&lang=js"
import style0 from "./LoaderUpdated.vue?vue&type=style&index=0&id=a54f86be&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports